export default __webpack_public_path__ + "static/slider-image-1-ab4a3a8fdd7b02ca9a50241a53c57d49.png";